import { useEffect, useRef } from 'react';

export function useBarcodeScanner(onScan, { timeout = 100 } = {}) {
  const buffer = useRef('');
  const timer = useRef(null);
  const onScanRef = useRef(onScan);
  
  // Keep onScanRef updated without triggering re-registration
  useEffect(() => {
    onScanRef.current = onScan;
  }, [onScan]);
  
  useEffect(() => {
    const handle = (e) => {
      if (e.key === 'Enter') {
        const code = buffer.current;
        buffer.current = '';
        if (code.length >= 3) onScanRef.current(code);
        return;
      }
      if (e.key.length === 1) {
        buffer.current += e.key;
        clearTimeout(timer.current);
        timer.current = setTimeout(() => { buffer.current = ''; }, timeout);
      }
    };
    window.addEventListener('keydown', handle);
    return () => window.removeEventListener('keydown', handle);
  }, [timeout]); // Only depend on timeout, not onScan
}
